module.exports = __webpack_public_path__ + "img/aliyun.fddf27fb.png";